import { observable, action, toJS } from "mobx";
import { toast } from "react-toastify";
import config from "../config";
import Http from "axios";

class AdminStore {
	@observable
	statistics = {
		monthlyEarnings: 0,
		monthlyRentals: 0,
		activeRentals: 0,
		expiredRentals: 0
	};
	@observable
	activeRentals = [];
	@observable
	expiredRentals = [];
	@observable
	users = [];
	@observable
	categories = [];
	@observable
	products = { docs: [], page: 0, pages: 0, total: 0 };
	@observable
	searchedProducts = [];
	@observable
	page = 0;
	@observable
	searching = false;
	@observable userProfile = null;
	@observable userOrders = [];

	@action async getUserOrders(userId) {
		const user = await Http.get(
			config.api + "/admin/users/" + userId + "/orders",
			{
				withCredentials: true
			}
		);
		this.userOrders = user.data.result;

		return user.data.result;
	}

	@action async getUserProfile(userId) {
		const user = await Http.get(config.api + "/admin/users/" + userId, {
			withCredentials: true
		});
		this.userProfile = user.data.result;

		return user.data.result;
	}

	@action
	getMonthlyEarnings() {
		Http.get(config.api + "/admin/earnings", {
			withCredentials: true
		}).then(earnings => {
			this.statistics.monthlyEarnings = earnings.data.result;
		});
	}

	@action
	setProductsPage = async (page, reset) => {
		if (
			(this.products.pages > 0 &&
				(page ? page : this.page) === this.products.pages) ||
			this.page !== this.products.page
		) {
			return;
		}

		this.page = page ? page : this.page + 1;
		const products = await Http.post(
			config.api + "/admin/products",
			{
				page: this.page
			},
			{
				withCredentials: true
			}
		);

		this.products = reset
			? products.data.result
			: {
					...products.data.result,
					docs: [...this.products.docs, ...products.data.result.docs]
			  };
	};

	@action
	addProduct(product) {
		this.products.docs = [product, ...this.products.docs];
	}

	@action
	setProducts(products) {
		this.products = products;
	}

	@action
	removeProduct(productId) {
		Http.post(
			config.api + "/admin/products/remove",
			{
				productId
			},
			{
				withCredentials: true
			}
		).then(product => {
			this.products = {
				...this.products,
				docs: this.products.docs.filter(
					currentProduct => currentProduct._id !== product.data.result._id
				)
			};
			toast.info("Removed product successfully");
		});
	}

	@action
	modifyProduct(product) {
		this.products = {
			...this.products,
			docs: this.products.docs.map(prevProduct =>
				prevProduct._id === product._id
					? { ...product, image: prevProduct.image }
					: prevProduct
			)
		};
	}

	@action
	getMonthlyRentals() {
		Http.get(config.api + "/admin/rentals", {
			withCredentials: true
		}).then(rentals => {
			this.statistics.monthlyRentals = rentals.data.result;
		});
	}

	@action
	getActiveRentals(count) {
		Http.get(config.api + "/admin/rentals/active" + (count ? "/count" : ""), {
			withCredentials: true
		}).then(rentals => {
			count
				? (this.statistics.activeRentals = rentals.data.result)
				: (this.activeRentals = rentals.data.result);
		});
	}

	@action
	filterOrder(id) {
		this.activeRentals = this.activeRentals.filter(rental => rental._id !== id);
		this.expiredRentals = this.expiredRentals.filter(
			rental => rental._id !== id
		);
	}

	@action
	getExpiredRentals(count) {
		Http.get(config.api + "/admin/rentals/expired" + (count ? "/count" : ""), {
			withCredentials: true
		}).then(rentals => {
			count
				? (this.statistics.expiredRentals = rentals.data.result)
				: (this.expiredRentals = rentals.data.result);
		});
	}

	@action
	getUsers() {
		Http.get(config.api + "/admin/users", {
			withCredentials: true
		}).then(users => {
			this.users = users.data.result;
		});
	}

	@action
	getCategories = async () => {
		const categories = await Http.get(config.api + "/categories");
		this.categories = categories.data.result.reduce((categories, category) => {
			console.log(category.parentCategory);
			const subCategory = category.parentCategory
				? categories.reduce((isSubcategory, parentCategory, key) => {
						console.log(parentCategory.subCategories);
						return isSubcategory
							? isSubcategory
							: parentCategory.subCategories.indexOf(category._id) > -1
							? { ...parentCategory, key }
							: isSubcategory;
				  }, false)
				: false;
			return subCategory
				? [
						...categories.slice(0, subCategory.key + 1),
						category,
						...categories.slice(subCategory.key + 1)
				  ]
				: [...categories, category];
		}, []);
	};

	@action
	getProducts() {
		Http.get(config.api + "/admin/products", {
			withCredentials: true
		}).then(products => {
			this.products = products.data.result;
			this.page = products.data.result.page;
		});
	}

	@action
	setSearchProducts = (products, query) => {
		this.searching = !!query;
		this.searchedProducts = products;
	};

	@action
	createCategory(category) {
		console.log("Categories", [...toJS(this.categories), category]);
		this.categories = [...toJS(this.categories), category].reduce(
			(categories, category) => {
				console.log(category.parentCategory);
				const subCategory = category.parentCategory
					? categories.reduce((isSubcategory, parentCategory, key) => {
							console.log(parentCategory.subCategories);
							return isSubcategory
								? isSubcategory
								: parentCategory._id === category.parentCategory
								? { ...parentCategory, key }
								: isSubcategory;
					  }, false)
					: false;
				return subCategory
					? [
							...categories.slice(0, subCategory.key + 1),
							category,
							...categories.slice(subCategory.key + 1)
					  ]
					: [...categories, category];
			},
			[]
		);
		toast.info("Created category successfully");
	}

	@action
	deleteCategory(categoryId) {
		Http.post(
			config.api + "/admin/categories/delete",
			{
				categoryId
			},
			{
				withCredentials: true
			}
		).then(({ data }) => {
			this.categories = this.categories.filter(
				category => data.result.indexOf(category._id) === -1
			);
			toast.info("Deleted category successfully");
		});
	}
}

const Admin = new AdminStore();

export default Admin;



// WEBPACK FOOTER //
// ./src/stores/AdminStore.js